window.jQuery = window.$ = require('jquery');
require('./bootstrap');

require('slick-carousel');
require('./plugins/fade');
require('./Main');
